/* TDS Match Quiz (7A). Steps: 0 name, 1 focus, 2 format, 3 age, 4 result. */
(function () {
  var CHECK = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  function clean(s) { s = (s || '').replace(/[<>&"']/g, '').trim().slice(0, 24); return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; }

  function init(root) {
    if (root.dataset.mqBound) return;
    root.dataset.mqBound = '1';
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-mq-data]').textContent) || {}; } catch (e) { data = {}; }
    var st = { step: 0, name: '', focus: null, format: null, age: null, labels: {} };
    var steps = root.querySelectorAll('[data-mq-step]');
    var segs = root.querySelectorAll('.mq-segs i');
    var back = root.querySelector('[data-mq-back]');
    var label = root.querySelector('[data-mq-label]');
    var nameIn = root.querySelector('[data-mq-name]');
    var dog = function () { return st.name || 'your dog'; };

    function has(k) { return k && data[k]; }
    function pick() {
      var f = st.focus, fm = st.format, main = null;
      if (fm === 'bed' && has('bed')) main = 'bed';
      else if (fm === 'powder' && has('powder')) main = 'powder';
      else if (fm === 'chew' && f === 'rest' && has('calm')) main = 'calm';
      else if (fm === 'chew' && f === 'gut' && has('powder')) main = 'powder';
      else if (has(f)) main = f;
      if (!main) main = Object.keys(data).filter(function (k) { return data[k]; })[0];
      var alt = null;
      if (has(f) && f !== main && data[f].url !== data[main].url) alt = f;
      else if (st.age === 'senior' && has('joint') && main !== 'joint') alt = 'joint';
      else if (has('bed') && data.bed.url !== data[main].url) alt = 'bed';
      else if (has('calm') && main !== 'calm') alt = 'calm';
      return { main: main, alt: alt };
    }

    function setR(attr, key, prod) {
      root.querySelectorAll('[' + attr + ']').forEach(function (el) {
        var f = el.getAttribute(attr), v = prod ? prod[f] : '';
        if (f === 'img') { if (prod) { el.src = key === 'a' ? prod.thumb : prod.img; el.alt = key === 'a' ? '' : prod.name; } }
        else if (f === 'url') { el.href = prod ? prod.url : '#'; }
        else if (f === 'add') { el.setAttribute('data-card-add', prod ? prod.variant : ''); el.setAttribute('aria-label', 'Add ' + (prod ? prod.name : '') + ' to cart'); }
        else if (f === 'head') { el.textContent = 'A good first pick for ' + dog() + '.'; }
        else el.textContent = v || '';
      });
    }

    function render() {
      steps.forEach(function (s) { s.hidden = parseInt(s.getAttribute('data-mq-step'), 10) !== st.step; });
      segs.forEach(function (g, i) { g.className = i < st.step ? 'is-done' : (i === st.step ? 'is-cur' : ''); });
      back.hidden = !(st.step > 0 && st.step < 4);
      label.textContent = st.step >= 4 ? 'Your pick' : 'Question ' + (st.step + 1) + ' of 4';
      root.classList.toggle('is-done', st.step >= 4);
      var vals = { name: st.name || (st.step > 0 ? 'Not given' : ''), focus: st.labels.focus, format: st.labels.format, age: st.labels.age };
      root.querySelectorAll('[data-mq-v]').forEach(function (dd) {
        var v = vals[dd.getAttribute('data-mq-v')];
        dd.textContent = v || '—';
        dd.classList.toggle('is-empty', !v);
      });
      var q1 = root.querySelector('[data-mq-q1]'); if (q1) q1.textContent = 'What would you like to focus on for ' + dog() + '?';
      var q3 = root.querySelector('[data-mq-q3]'); if (q3) q3.textContent = 'How old is ' + dog() + '?';
      root.querySelectorAll('.mq-opt').forEach(function (b) {
        b.setAttribute('aria-pressed', st[b.getAttribute('data-q')] === b.getAttribute('data-v') ? 'true' : 'false');
      });
      if (st.step >= 4) {
        var r = pick();
        setR('data-mq-r', 'r', data[r.main]);
        var alt = root.querySelector('.mq-alt');
        alt.hidden = !r.alt;
        if (r.alt) setR('data-mq-a', 'a', data[r.alt]);
        var m = root.querySelector('[data-mq-matched]');
        m.innerHTML = '';
        ['focus', 'format', 'age'].forEach(function (k) {
          if (!st.labels[k]) return;
          var c = document.createElement('span'); c.className = 'mq-chip';
          c.innerHTML = CHECK; c.appendChild(document.createTextNode(st.labels[k]));
          m.appendChild(c);
        });
      }
    }

    function go(n, focusIt) {
      st.step = n; render();
      if (focusIt) {
        var cur = root.querySelector('[data-mq-step="' + n + '"]');
        var h = cur && (n === 0 ? nameIn : cur.querySelector('.mq-q'));
        if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
        var card = root.querySelector('.mq-card'), top = card.getBoundingClientRect().top;
        if (top < 70 || top > window.innerHeight * 0.6) window.scrollTo({ top: top + window.pageYOffset - 90, behavior: 'smooth' });
      }
    }

    root.querySelector('[data-mq-next]').addEventListener('click', function () { st.name = clean(nameIn.value); go(1, true); });
    root.querySelector('[data-mq-skip]').addEventListener('click', function () { st.name = ''; nameIn.value = ''; go(1, true); });
    nameIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); st.name = clean(nameIn.value); go(1, true); } });
    back.addEventListener('click', function () { go(Math.max(0, st.step - 1), true); });
    root.querySelector('[data-mq-restart]').addEventListener('click', function () {
      st = { step: 0, name: '', focus: null, format: null, age: null, labels: {} }; nameIn.value = ''; go(0, true);
    });
    root.querySelectorAll('.mq-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        if (root.dataset.mqBusy) return;
        root.dataset.mqBusy = '1';
        var q = b.getAttribute('data-q');
        st[q] = b.getAttribute('data-v'); st.labels[q] = b.getAttribute('data-label');
        render();
        setTimeout(function () { delete root.dataset.mqBusy; go(st.step + 1, true); }, 180);
      });
    });
    render();
  }

  function boot() { document.querySelectorAll('[data-mq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
